import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    agentListValue: {},
    agentListLoading: false,
    teamsListValue: {},
    userTeams: {},
    pageTeams: {},
    teamsListLoading: false,
    agentOption: [],
    filterUpdated: 0,

    selectedPageOption: ["selectAll"],
    filters: {
        // duration: "30",
        // entitySubType: "all",
        // entityType: "all",
        // isSMRAnalytics: true,

        creationDuration: "30", //all
        updateDuration: "30",
        entitySubType: "all",
        entityType: "all",
    },

    filterRefineFilter: {
        sentiment: ["all"],
        exclusion: "yes",
        messageTypeOption: ["selectAll"],
        statusOption: ["selectAll"],
        priorityOption: ["selectAll"],
        tagsOption: ["selectAll"],
        ratingsOption: ["selectAll"],
        spamOptions: "0",
        keywordOption: [],
    },
    custom_query: "",

    sortOption: "published_date_desc",

    smrChartData: {},
    smrChartDataLoading: {},
    smrChartDataError: {},
};

const SMRAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SMR_ANALYTICS_SELECTED_PAGES":
            return (state = {
                ...state,
                selectedPageOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case "SMR_ANALYTICS_SET_CUSTOM_QUERY":
            return { ...state, custom_query: action.payload, filterUpdated: state.filterUpdated + 1 };

        case "SMR_ANALYTICS_SET_FILTERS":
            //console.log("action.payload", action.payload);
            return (state = {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            });

        case isPending("FETCH_SMR_ANALYTICS_CHART_DATA"): {
            //console.log("firstSMR", action.chart);
            const smrChartDataLoading = state.smrChartDataLoading;
            const smrChartDataError = state.smrChartDataError;

            smrChartDataLoading[action.chart] = true;
            smrChartDataError[action.chart] = null;

            return { ...state, smrChartDataLoading, smrChartDataError };
        }
        case isRejected("FETCH_SMR_ANALYTICS_CHART_DATA"): {
            //console.log("firstSMR");
            const smrChartDataLoading = state.smrChartDataLoading;
            const smrChartDataError = state.smrChartDataError;

            smrChartDataLoading[action.chart] = false;
            smrChartDataError[action.chart] = action.payload;

            return { ...state, smrChartDataLoading, smrChartDataError };
        }

        case isFulfilled("FETCH_SMR_ANALYTICS_CHART_DATA"):
        case "SET_SMR_ANALYTICS_CHART_DATA": {
            //console.log("firstSMR", action.chart);
            const smrChartDataLoading = state.smrChartDataLoading;
            const smrChartDataError = state.smrChartDataError;
            const smrChartData = state.smrChartData;

            smrChartDataLoading[action.chart] = false;
            smrChartDataError[action.chart] = null;
            smrChartData[action.chart] = action.payload;

            return { ...state, smrChartDataLoading, smrChartDataError, smrChartData };
        }

        case "SMR_ANALYTICS_CLEANUP": {
            return initialState;
        }
        default:
            return state;
    }
};

export default SMRAnalyticsReducer;
